import { useEffect, useState } from "react";
import { Ticket, CheckCircle2, XCircle, Clock, Radio, Bot } from "lucide-react";
import { http } from "@/lib/api";

function PickStatus({ p }) {
  if (p.hit === true) return <span className="flex items-center gap-1 text-[var(--win)]"><CheckCircle2 size={14} /> VINTA</span>;
  if (p.hit === false) return <span className="flex items-center gap-1 text-[var(--loss)]"><XCircle size={14} /> PERSA</span>;
  if (p.status === "IN_PLAY" || p.status === "PAUSED") return <span className="flex items-center gap-1 text-[var(--loss)] animate-pulse"><Radio size={14} /> LIVE</span>;
  return <span className="flex items-center gap-1 text-[var(--gold)]"><Clock size={14} /> {p.time}</span>;
}

function Pick({ p, n }) {
  return (
    <li data-testid={`schedina-pick-${n}`} className="relative grid grid-cols-[auto_1fr_auto] items-center gap-4 py-5 border-b border-dashed border-slate-700 last:border-0 fade-up" style={{ animationDelay: `${n * 90}ms` }}>
      <span className="font-display text-4xl font-extrabold text-slate-700 w-8">{n}</span>
      <div className="min-w-0">
        <div className="text-[11px] font-mono uppercase text-slate-400 flex flex-wrap gap-x-3">{p.competition_name} <PickStatus p={p} /></div>
        <div className="flex items-center gap-2 mt-1 font-semibold">
          <img src={p.home_crest} alt="" className="w-6 h-6 object-contain" /><span className="truncate">{p.home}</span>
          <span className="text-slate-500">{p.score || "vs"}</span>
          <span className="truncate">{p.away}</span><img src={p.away_crest} alt="" className="w-6 h-6 object-contain" />
        </div>
        <div className="text-xs text-slate-500 mt-1 truncate">{p.consiglio}</div>
      </div>
      <div className="text-right">
        <div className="text-[10px] uppercase tracking-wider text-slate-500">{p.market}</div>
        <div className={`font-display font-extrabold text-[var(--gold)] leading-none ${p.pick.length > 4 ? "text-2xl" : "text-4xl"}`}>{p.pick}</div>
        <div className="font-mono text-xs text-slate-400 mt-1">{p.prob}%</div>
      </div>
    </li>
  );
}

export default function Schedina({ tg }) {
  const [s, setS] = useState(null);
  useEffect(() => { http.get("/public/schedina").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="panel h-64 scan" />;

  return (
    <div className="grid lg:grid-cols-[1.4fr_1fr] gap-6 items-start">
      <div data-testid="schedina-ticket" className="panel pitch-lines p-6 sm:p-8">
        <div className="flex items-center justify-between gap-4 border-b border-slate-800 pb-5">
          <div>
            <span className="font-mono text-xs text-[var(--gold)] tracking-widest">SCHEDINA DEL GIORNO</span>
            <h3 data-testid="schedina-date" className="font-display text-4xl font-extrabold uppercase">{s.label}</h3>
          </div>
          <Ticket size={40} className="text-[var(--gold)] -rotate-12" />
        </div>
        {s.picks.length === 0 ? (
          <p data-testid="schedina-empty" className="text-slate-400 py-8">Nessuna partita con pronostico disponibile nei prossimi giorni.</p>
        ) : (
          <ol>{s.picks.map((p, i) => <Pick key={p.match_id} p={p} n={i + 1} />)}</ol>
        )}
        {s.picks.length > 0 && (
          <div className="flex items-center justify-between pt-5 border-t border-slate-800">
            <span className="text-sm text-slate-400">Probabilità combinata</span>
            <span data-testid="schedina-combined" className="font-display text-3xl font-extrabold">{s.combined_prob}%</span>
          </div>
        )}
      </div>
      <div className="panel p-6 space-y-4">
        <h4 className="font-display text-2xl font-bold uppercase">Come la scegliamo</h4>
        <p className="text-sm text-slate-300 leading-relaxed">Tra tutti i pronostici AI del giorno selezioniamo le 3-4 giocate con la probabilità più alta, privilegiando le doppie chance più solide. A fine partita ogni giocata viene segnata come vinta o persa.</p>
        <a data-testid="schedina-telegram-btn" href={tg} target="_blank" rel="noreferrer" className="btn btn-tg"><Bot size={16} /> Ricevila su Telegram con /schedina</a>
        <p className="text-xs text-slate-500">Solo a scopo informativo. Gioca responsabilmente (18+).</p>
      </div>
    </div>
  );
}
